import type {
  BlockRoomRequestDto,
  CreateHousekeepingTaskRequestDto,
  ReleaseRoomBlockRequestDto,
  ReportMaintenanceIssueRequestDto,
  UpdateHousekeepingTaskRequestDto,
  UpdateMaintenanceReportRequestDto,
  UpdateRoomStateRequestDto,
} from "./contracts/dtos.ts";
import {
  blockRoom,
  createHousekeepingTask,
  releaseRoomBlock,
  reportMaintenanceIssue,
  updateHousekeepingTask,
  updateMaintenanceReport,
  updateRoomState,
} from "./service.ts";
import type { HousekeepingContext } from "./types.ts";

export const housekeepingEndpoints = {
  createTask: (
    request: CreateHousekeepingTaskRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => createHousekeepingTask(request, context, deps),
  updateTask: (
    request: UpdateHousekeepingTaskRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => updateHousekeepingTask(request, context, deps),
  updateRoomState: (
    request: UpdateRoomStateRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => updateRoomState(request, context, deps),
  reportMaintenance: (
    request: ReportMaintenanceIssueRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => reportMaintenanceIssue(request, context, deps),
  updateMaintenance: (
    request: UpdateMaintenanceReportRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => updateMaintenanceReport(request, context, deps),
  blockRoom: (
    request: BlockRoomRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => blockRoom(request, context, deps),
  releaseRoomBlock: (
    request: ReleaseRoomBlockRequestDto,
    context: HousekeepingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => releaseRoomBlock(request, context, deps),
};
